<template>
    <component
        :is="customContent ? 'span' : 'q-icon'"
        :size="size"
        :name="iconname"
        :style="iconstyle"
        color="ciconcolor"
        class="cursor-pointer"
        :class="{
            '-userprofile-info__toggle' : !customContent
        }"
        @click.stop.prevent
        :data-component-name="$options.name"
    >
        <span v-if="customContent!==false" v-html="customContent"></span>
        <q-menu transition-show="scale" transition-hide="scale"
            ref="userProfileProxy"
            v-model="proxyVisible"
            anchor="bottom middle"
        >
            <!-- {{ userProfile }} -->
            <UserProfileInfoDetails 
                :userProfileSrc="userProfile"
                :forceType="forceType"
                :currentDate="currentDate"
                :defaultTab="defaultTab"
                :scheduleScrollTo="scheduleScrollTo"
                @update-proxy="updateProxyPosition()"
                @hide-proxy="proxyVisible=false"
            />
        </q-menu>

    </component>
</template>
<script>

    export default {
        name: 'UserProfileInfo',
        //components: { Component1, Component2 },
        props: {
        	userProfile:{
        		type: Object,
        		default() {
                    return null
                },
        	},
            currentDate: {
                type: String,
                default: null
            },
            iconcolor:{
                type: String,
                default: null
            },
            customContent: {
                type: [String, Boolean, Number],
                default: false
            },
            size: {
                type: [Number, String],
                default: null
            },
            defaultTab: {
                type: String,
                default: null
            },
            scheduleScrollTo: {
                type: String,
                default: null
            },
            iconname: {
                type: String,
                default: 'info'
            },
            forceType: {
                type: String,
                default: "userProfiles"
            },
        },
        data(){
        	return {
                proxyVisible: false,
                offset: [0, 0],
        	}
        },
        // mounted(){
        // },
        computed: {
            companyInfo(){
                if(!this.userProfile.company && !this.userProfile.customer ) return null;

                if(this.userProfile.company) return this.userProfile.company
                if(this.userProfile.customer) return this.userProfile.customer
                return null
            },

            iconstyle() {

                if (this.customContent) return null

                if (this.userProfile?.company?.categories.length > 0) {
                    // return 'border-radius: 50%; border-right: 2px solid ' + this.userProfile.company.categories[0].color + '; border-left: 2px solid ' + this.userProfile.company.categories[0].color + ';'
                    return 'color: ' + this.userProfile.company.categories[0].color + ';';
                    
                }

                return this.iconcolor
            }
        },
        // watch: {
        // },
        methods: {
            updateProxyPosition(){
                this.$refs.userProfileProxy.updatePosition();
                this.$nextTick(() => {
                    setTimeout(() => {
                        
                        let panel = this.$refs.userProfileProxy.$children[0].$el
                        let left = panel.getBoundingClientRect().left
    
                        if(left+panel.offsetWidth > window.innerWidth){
                            panel.style.left = (left+panel.offsetWidth-window.innerWidth)+'px';
                        }
                    }, 500);
                })
            }
        },
    }
</script>
<style lang="scss">
    .q-menu.q-position-engine.scroll{
        @include media("<md") {
            max-width: 90vw !important;
        }
    }
</style>
<style lang="scss" scoped>
    .avatar-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 15px;
    }

    .-userprofile-info {

        &__toggle {
            font-size: 1.1em;
            color: $color-0;
            margin-top: -1px;
        }

        // &__wrap {
        //     background-color: $color-0-lightest;
        //     padding: 20px;
        //     min-width: 300px;
        //     max-width: 450px;
        // }

        .-row-info {
            display: flex;
            flex-direction: row;
            font-size: 10px;
            flex-wrap: wrap;

            & .-col-info {
                min-width: 50%;
                flex-grow: 1;
                display: flex;
                flex-direction: row;

                .q-icon {
                    margin-top: -2px;
                }
                > .q-icon {
                    margin-top: 1px;
                }
            }
        }
    }
</style>